/* globals Chart:false, feather:false */
var vid = document.getElementById("mapView"); 
var vid2 = document.getElementById("mapView2"); 
var progressBar = document.querySelector(".progress-bar");
var progress = 0;
var startVideoTime = 0;
var videoBarWidth = 0;

// length of demo video (unit : seconds)
var vidBase = 310.2;

export function playVid(video) { 
  vid.play();
  vid2.play(); 
  startBar(video);
} 

export function pauseVid() { 
  vid.pause(); 
  vid2.pause();
  stopProgress();
} 

export function stopVid() { 
  vid.pause(); 
  vid.currentTime = 0;
  vid2.pause(); 
  vid2.currentTime = 0;
  resetBar();
} 

//document.getElementById('mapView').addEventListener('ended',myHandler,false);
export function myHandler(e) {
  if (document.getElementById('flexCheckChecked').checked) {
    console.log("download csv");
    downloadFile('https://drive.google.com/u/2/uc?id=1jLlS-e40wuNCIkR134IziMq0kZlv4B_Q&export=download'); //TODO: this is sample file, may be need to update new files for each scenario
  } 
}

export function downloadFile(filePath){
  var link=document.createElement('a');
  link.href = filePath;
  link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
  link.click();
}

export function moveBar() {
  if(progress < 100){
    progress = progress + 1;
    progressBar.style.width = progress + "%";
    progressBar.innerText = progress + "%";
  }
}

//Get Current Value of attributes
export function getProgress() {
	return progressBar.getAttribute("aria-valuenow");
	return progressBar.getAttribute("style","width:");
	return progressBar.innerHTML;
	}

//Set value of attributes
export function setProgress(value) {
	progressBar.setAttribute("aria-valuenow",value);
	progressBar.setAttribute("style","width: " +value+ "%");	
	progressBar.innerHTML = (value+ "%"); 
}

//Current value set back to 0.
export function resetBar() {
  stopProgress();
	var r = getProgress();
	setProgress(r = 0);
}

//Auto complete value to max in this case max is 100 with Interval of 100.
export function startBar(video) {
  var vidSce = getVideo(video);
  var end = (vidBase > vidSce) ? vidBase : vidSce;
	clearInterval(progress);
  progress = setInterval(frame, 1000); //run within bar(interval) for each second = 1000 miliseconds
	function frame(){
		if(videoBarWidth == 100){
      startVideoTime = 0;
      videoBarWidth = 0;
			clearInterval(progress);
		}else{
      videoBarWidth = startVideoTime * 100 / end;
			progressBar.style.width = videoBarWidth + '%';
			progressBar.innerHTML = getMonth(videoBarWidth);
			startVideoTime++;
		}
	}
}

//Stop Auto complete value at current value when button is pressed.
export function stopProgress(){
	clearInterval(progress);
}

export function getVideo(vid){
  var vidTime = 0;
  if(vid == '1'){
    vidTime = 303.6;
  } else if(vid == '2'){
    vidTime = 324;
  } else if(vid == '3'){
    vidTime = 425.4;
  } else if(vid == '4'){
    vidTime = 249.6;
  } else if(vid == '5'){
    vidTime = 310.2;
  }    
  return vidTime;
}

export function getMonth(width){
  var month;
  if(width <= 9)
    month = 'January';
  else if(width <= 16)
    month = 'February';
  else if(width <= 25)
    month = 'March';
  else if(width <= 33)
    month = 'April';  
  else if(width <= 42)
    month = 'May';
  else if(width <= 49)
    month = 'June';
  else if(width <= 57)
    month = 'July';
  else if(width <= 65)
    month = 'August';
  else if(width <= 73)
    month = 'September';
  else if(width <= 81)
    month = 'October';
  else if(width <= 89)
    month = 'November';
  else if(width < 100)
    month = 'December';
  else 
    month = 'Complete';
  return month; 
}